import styles from "./Header.module.css";

type TaskFormHeaderProps = {
  number: string;
  label: string;
};

function Header({ number, label }: TaskFormHeaderProps) {
  return (
    <div className={styles["root"]}>
      <div className={styles["blob"]}>{number}</div>
      <h2 className={styles["label"]}>{label}</h2>
    </div>
  );
}

export default Header;
